import React, { useState } from 'react';
import { Select, Modal } from 'antd';
import { useQuery, useMutation } from '@common/hooks';
import {
  PerformWorksShiftAction,
  WorksShiftRejectionReasons,
  WorksShiftRejectionReasonsResponse,
} from '@scheduling/graphql';
import { createMessage } from 'works/legacy/lib/message-helper';
import { TextAreaEmojiPicker, Form, Text } from '@common/components';
export function ShiftRejectModal({
  worksShiftId,
  open,
  setOpen,
}: {
  worksShiftId: string | undefined;
  open: boolean;
  setOpen: (value: boolean) => void;
}) {
  const [form] = Form.useForm();
  const [note, setNote] = useState('');

  const { data: rejectedReasons } =
    useQuery<WorksShiftRejectionReasonsResponse>(WorksShiftRejectionReasons, {
      variables: {
        reasonType: 'rejection',
      },
    });

  const [rejectedWorksShift, { loading: rejectLoading }] = useMutation(
    PerformWorksShiftAction,
    {
      onError: () => {
        createMessage(
          'error',
          'Shift could not be rejected. Please try again or contact your hiring partner.'
        );
      },
      refetchQueries: [
        'ShiftGapDetails',
        'PaginatedShiftGapOpenings',
        'PaginatedShiftGapOpeningsCount',
        'ShiftsByDay',
      ],
    }
  );

  return (
    <>
      <Modal
        open={open}
        onCancel={() => {
          setOpen(false);
        }}
        cancelText="No, Go Back"
        onOk={form.submit}
        okText="Yes, Reject"
        title="Are you sure you want to reject this shift?"
        okButtonProps={{ loading: rejectLoading }}
      >
        <Text>This action cannot be undone.</Text>
        <Form
          form={form}
          layout="vertical"
          className="shift-reject-form"
          onFinish={(values) => {
            rejectedWorksShift({
              variables: {
                worksShiftId: worksShiftId || '',
                input: {
                  action: 'reject',
                  rejectionReasonCode: values.rejectedReason,
                  managerNote: note,
                },
              },
            });
            setOpen(false);
          }}
        >
          <Form.Item
            label="Reason"
            name="rejectedReason"
            rules={[
              { required: true, message: 'Please choose a reject reason' },
            ]}
          >
            <Select placeholder="Select a reason" style={{ width: '100%' }}>
              {rejectedReasons?.worksShiftRejectionReasons.map((reason) => (
                <Select.Option key={reason.id} value={reason.code}>
                  {reason.displayName}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item label="Notes" name="note">
            <TextAreaEmojiPicker rows={4} onChange={setNote} value={note} />
          </Form.Item>
        </Form>
      </Modal>
      <style jsx>
        {`
          :global(.shift-reject-form) {
            padding-top: 16px;
          }
        `}
      </style>
    </>
  );
}
